import {
  ItemDetailsDto,
  ItemDetailsSidebarSectionResp,
} from '@marketplace-web/domain/item-page-data'

import { ItemPageMarkAsSoldButtonPluginModel } from './types'

export const getItemPageMarkAsSoldButtonPluginModel = (
  itemDto: ItemDetailsDto,
): ItemPageMarkAsSoldButtonPluginModel => ({
  itemId: itemDto.id,
  transactionPermitted: itemDto.transaction_permitted,
  isClosed: itemDto.is_closed,
  userId: itemDto.user.id,
})

export const getServerItemPageMarkAsSoldButtonPluginModel = (
  sidebarDto: ItemDetailsSidebarSectionResp,
): ItemPageMarkAsSoldButtonPluginModel => ({
  itemId: sidebarDto.id,
  transactionPermitted: sidebarDto.transaction_permitted,
  isClosed: sidebarDto.is_closed,
  userId: sidebarDto.seller_id,
})
